import { useState } from 'react'
import supabase from '../db/supabase.client.js'
import DemoAccountsBanner from './DemoAccountsBanner.jsx'

/**
 * LoginPage component provides authentication UI.
 * Simple email/password login for MVP.
 *
 * @returns {React.ReactElement} Login page
 */
export default function LoginPage() {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState(null)

  const handleSubmit = async (event) => {
    event.preventDefault()

    // Guard: validate inputs
    if (!email || !password) {
      setError('Wprowadź email i hasło.')
      return
    }

    setIsLoading(true)
    setError(null)

    try {
      const { error } = await supabase.auth.signInWithPassword({
        email,
        password,
      })

      if (error) {
        setError('Nieprawidłowy email lub hasło.')
        console.error('Login error:', error)
      }
      // On success, useAuthSession will detect the session change
      // and ProtectedRoute will redirect to /app
    } catch (err) {
      setError('Błąd połączenia. Spróbuj ponownie.')
      console.error('Unexpected login error:', err)
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <div className="login-page">
      <div className="login-page__container">
        <div className="login-page__header">
          <h1 className="login-page__title">Szybkie Fiszki</h1>
          <p className="login-page__subtitle">Zaloguj się, aby kontynuować</p>
        </div>

        <DemoAccountsBanner />

        <form className="login-form" onSubmit={handleSubmit}>
          {error && (
            <div className="login-form__error" role="alert">
              {error}
            </div>
          )}

          <div className="login-form__field">
            <label htmlFor="email" className="login-form__label">
              Email
            </label>
            <input
              id="email"
              type="email"
              className="login-form__input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              disabled={isLoading}
              autoComplete="email"
              required
            />
          </div>

          <div className="login-form__field">
            <label htmlFor="password" className="login-form__label">
              Hasło
            </label>
            <input
              id="password"
              type="password"
              className="login-form__input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              disabled={isLoading}
              autoComplete="current-password"
              required
            />
          </div>

          <button
            type="submit"
            className="login-form__submit"
            disabled={isLoading}
          >
            {isLoading ? 'Logowanie...' : 'Zaloguj się'}
          </button>
        </form>
      </div>
    </div>
  )
}
